import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    type: 'Player Feedback',
    quote: "Working with Alou has helped me become more confident in my shot. I'm starting to see real improvement, and the things he's teaching me are translating to my game.",
    author: '— Dillon Blueprint Athlete',
  },
  {
    type: 'Parent Feedback',
    quote: "We've seen a noticeable difference in his confidence and in the way he's playing since working with Alou. The growth has been clear.",
    author: '— Parent of Dillon Blueprint athlete',
  },
  {
    type: 'Player Feedback',
    quote: "Alou has helped make me a quicker, smarter player with the ball. The time he's spent developing my game is showing, and I feel like I've become a better all-around player.",
    author: '— Dillon Blueprint Athlete',
  },
];

export const Testimonials = () => {
  return (
    <section data-testid="testimonials" className="bg-black py-14 sm:py-16 lg:py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <p className="text-gray-400 font-bold text-xs tracking-[0.35em] uppercase mb-4">— The Dillon Blueprint —</p>
          <h2 className="font-display text-white text-4xl sm:text-6xl uppercase leading-tight">
            What Players &amp;<br />Parents Are Saying
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed max-w-xl mx-auto mt-5">
            Real feedback from athletes and families seeing growth in confidence, skill, and game performance.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              data-testid={`testimonial-card-${i}`}
              className="rounded-2xl border border-neutral-800 hover:border-gray-500 bg-neutral-950 p-8 flex flex-col transition-colors duration-300"
            >
              <Quote className="w-8 h-8 text-gray-400 mb-4 rotate-180" strokeWidth={1.5} fill="currentColor" />
              <div className="text-gray-300 font-bold text-xs tracking-[0.25em] uppercase mb-1">{t.type}</div>
              <div className="w-8 h-0.5 bg-gray-400 mb-5" />
              <p className="text-white text-lg italic leading-relaxed">"{t.quote}"</p>
              <p className="text-gray-500 text-sm italic mt-auto pt-8">{t.author}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          data-testid="testimonials-footer-bar"
          className="rounded-2xl border border-neutral-800 bg-neutral-950 p-6 mt-8 text-center"
        >
          <p className="font-display text-xl uppercase tracking-wide">
            <span className="text-white">Confidence.</span>{' '}
            <span className="text-gray-400">Growth.</span>{' '}
            <span className="text-white">Real Player Development.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};
